import React from 'react';
import { Grid, TextField, MenuItem, Autocomplete, FormControl, InputLabel, Select, FormHelperText } from '@mui/material';
import { roomOptions, wardOptions, surgeryOptions, anaesthesiaOptions } from '../constants/options';

const PatientDetailsSection = ({ formData, setFormData, errors, handleInputChange, handleBlur }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Patient Name"
          name="pt_name"
          value={formData.pt_name || ''}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          fullWidth
          label="Age"
          name="age"
          value={formData.age || ''}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          select
          fullWidth
          label="Gender"
          name="sex"
          value={formData.sex || ''}
          InputProps={{ readOnly: true }}
        >
          <MenuItem value="Male">Male</MenuItem>
          <MenuItem value="Female">Female</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="UHID No."
          name="uhid_no"
          value={formData.uhid_no || ''}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="IP No."
          name="ip_no"
          value={formData.ip_no || ''}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth required error={!!errors.ward_no}>
          <InputLabel>Ward No.</InputLabel>
          <Select
            name="ward_no"
            value={formData.ward_no || ''}
            onChange={handleInputChange}
            onBlur={handleBlur}
            label="Ward No."
          >
            {wardOptions.map((ward) => (
              <MenuItem key={ward} value={ward}>{ward}</MenuItem>
            ))}
          </Select>
          {errors.ward_no && <FormHelperText>{errors.ward_no}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth required error={!!errors.room_no}>
          <InputLabel>Room No.</InputLabel>
          <Select
            name="room_no"
            value={formData.room_no || ''}
            onChange={handleInputChange}
            onBlur={handleBlur}
            label="Room No."
          >
            {roomOptions.map((room) => (
              <MenuItem key={room} value={room}>{room}</MenuItem>
            ))}
          </Select>
          {errors.room_no && <FormHelperText>{errors.room_no}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Instruction Date"
          name="instruction_date"
          type="date"
          required
          value={formData.instruction_date || ''}
          onChange={handleInputChange}
          onBlur={handleBlur}
          error={!!errors.instruction_date}
          helperText={errors.instruction_date}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          freeSolo
          options={surgeryOptions}
          value={formData.surgery_done || ""}
          onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, surgery_done: newVal }))}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Surgery Done" 
              name="surgery_done"
              required 
              error={!!errors.surgery_done}
              helperText={errors.surgery_done}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Post Operative Day"
          name="postoperative_day"
          value={formData.postoperative_day || ''}
          onChange={handleInputChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Anaesthesiologist"
          name="anaesthesiologist"
          required
          value={formData.anaesthesiologist || ''}
          onChange={handleInputChange}
          onBlur={handleBlur}
          error={!!errors.anaesthesiologist}
          helperText={errors.anaesthesiologist}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          freeSolo
          options={anaesthesiaOptions}
          value={formData.anaesthesia || ""}
          onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, anaesthesia: newVal }))}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Anaesthesia Type" 
              name="anaesthesia"
              required 
              error={!!errors.anaesthesia}
              helperText={errors.anaesthesia}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default PatientDetailsSection;
